import styled from 'styled-components';

export const NoAppsContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

interface NoAppsProps {
  isMobile?: boolean;
}

export const NoAppsContent = styled.div<NoAppsProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 0 1rem;

  h1 {
    font: ${({ isMobile }) =>
      isMobile
        ? "600 1.2rem/1.5rem 'Segoe UI', sans-serif;"
        : "600 1.5rem/2rem 'Segoe UI', sans-serif;"};
    color: ${({ theme }: {theme: any}) => theme.black};
    text-align: center;
  }

  h3 {
    font: 400 1.1rem/1.2rem 'Segoe UI', sans-serif;
  }

  p {
    font: ${({ isMobile }) =>
      isMobile
        ? "400 0.9rem/1rem 'Segoe UI', sans-serif"
        : "400 1rem/1.1rem 'Segoe UI', sans-serif"};
    text-align: center;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  > img {
    height: 200px;
    width: 300px;
    object-fit: contain;
  }

  .buttonsContainer {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
`;

export const TrialModalContent = styled.div`
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;
  padding: 0 2rem 2rem;
  align-items: center;

  h1 {
    font: 600 1.5rem/2rem 'Segoe UI', sans-serif;
    text-align: center;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  p {
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }
`;
